import {customElement, property, state} from 'lit/decorators.js';
import { html, LitElement } from 'lit';
import { style } from './citation-teaser.styles';
import {query} from "lit/decorators/query.js";

// eslint-disable-next-line
declare const TYPO3: any;

@customElement('sbk-citation-teaser')
export class CitationTeaser extends LitElement {
  @property()
  heading: string = '';

  @property({ attribute: 'person-name' })
  personName: string = '';

  @property({ attribute: 'person-role' })
  personRole: string = '';

  @property()
  size: 'default' | 'large' = 'default';

  @property()
  variant: 'neutral' | 'muted' = 'muted';

  @query('.citation-teaser__quote')
  quoteContent!: HTMLDivElement;

  @state()
  showReadMoreButton = false;

  @state()
  isExpanded = false;
  
  static get styles() {
    return style;
  }

  render() {
    return html`
      <div class="citation-teaser citation-teaser--${this.size} citation-teaser--${this.variant}">
        <div class="citation-teaser__content">
          <div class="citation-teaser__quote${this.isExpanded ? ' expanded' : ''}">
            <slot></slot>
          </div>
          ${this.renderReadMoreButton()}
          <div>
            ${this.renderPerson()}
            ${this.renderPersonRole()}
          </div>
        </div>
        <sbk-icon class="citation-teaser__quote-icon" size='160' symbol='quotes' responsive="true"></sbk-icon>
      </div>
    `;
  }

  firstUpdated() {
    this.showReadMoreButton = this.quoteContent.scrollHeight > this.quoteContent.clientHeight
    const renderEvent = new CustomEvent('sbk-citation-teaser-rendered');
    this.dispatchEvent(renderEvent);
  }

  renderReadMoreButton() {
    if (!this.showReadMoreButton) {
      return '';
    }
    return this.isExpanded
        ? html`<sbk-link class="citation-teaser__button" @click=${this.toggleQuote} icon="chevron-up" icon-position="right">${this.getMessage('showLess')}</sbk-link>`
        : html`<sbk-link class="citation-teaser__button" @click=${this.toggleQuote} icon="chevron-down" icon-position="right">${this.getMessage('showMore')}</sbk-link>`
  }

  renderPerson() {
    return this.personName
      ? html`<p class="citation-teaser__person">${this.personName}</p>`
        : '';
  }

  renderPersonRole() {
    return this.personRole
        ? html`<p class="citation-teaser__person-role">${this.personRole}</p>`
        : '';
  }

  toggleQuote() {
    this.isExpanded = !this.isExpanded;
    const event = new CustomEvent('sbk-citation-teaser-quote-toggled');
    this.dispatchEvent(event);
  }

  getMessage(key: string): string {
    return typeof TYPO3 !== "undefined" ? TYPO3.lang[key] : key;
  }
}